import { Fragment, FunctionComponent } from 'react';

export interface AlternateBoldTextProps {
  text?: string[];
}

const AlternateBoldText: FunctionComponent<AlternateBoldTextProps> = function ({
  text,
}) {
  if (!text || text.length === 0) return undefined;
  return (
    <span>
      {text.map((snippet: string, index: number) => {
        const key = `${snippet}-${index}`;
        if (index % 2 === 0) return <Fragment key={key}>{snippet}</Fragment>;
        return <strong key={key}>{snippet}</strong>;
      })}
    </span>
  );
};

export default AlternateBoldText;
